import { IconAlarm, IconBrandInstagram, IconLink, IconMail, IconMessageChatbot, IconMessageCircle, IconSend, IconPhotoHeart, IconUserPlus } from '@tabler/icons-react';

// Contract 2.14.0 is `designing`: core has none of these routes yet, so only `?mock=true` (sticky
// in the tab, data/studioApi.mock.js) opens the screens; everywhere else the sidebar keeps the
// feature preview. Delete this when core ships them, along with the entry in futureFeatures.
const MOCK_KEY = 'ginastee:studio:mock';
export const automationsLive = (() => {
  try {
    const flag = new URLSearchParams(window.location.search).get('mock');
    if (flag === 'false') return false;
    return flag === 'true' || !!window.sessionStorage.getItem(MOCK_KEY);
  } catch { return false; }
})();

export const CHANNELS = ['comments', 'stories', 'direct_messages'];
export const CHANNEL_ICONS = { comments: IconMessageCircle, stories: IconPhotoHeart, direct_messages: IconSend };
export const OBJECTIVES = ['grow_followers', 'engage_audience', 'drive_traffic'];
export const CONNECT_PLATFORM_ICON = IconBrandInstagram;

// The sequence in the Direct, in the order it is sent (`StudioAutomationStepKey`).
export const SEQUENCE_ICONS = { comment_reply: IconMessageCircle, opening: IconMessageChatbot, follow_gate: IconUserPlus, email_capture: IconMail, delivery: IconLink, reminder: IconAlarm };

// The editor's steps and the fields each one owns, so an error from the server opens the right one.
export const EDITOR_STEPS = ['trigger', 'keywords', 'messages', 'delivery'];
export const stepOfField = field => {
  if (/^trigger\.keywords|^comment_reply/.test(field)) return 'keywords';
  if (/^trigger|^status/.test(field)) return 'trigger';
  if (/^dm\.(delivery|reminder)/.test(field)) return 'delivery';
  if (/^dm\./.test(field)) return 'messages';
  return null;
};

// Minutes a reminder can wait; the contract allows 15 to 1380 and the 24-hour window closes after that.
export const REMINDER_DELAYS = [15, 30, 60, 120, 360, 720, 1380];
export const LIMITS = { keywords: 20, keyword: 50, media: 20, replies: 5, reply: 300, buttons: 3, buttonTitle: 20, stepText: 640, emailText: 1000, deliveryText: 1000, deliveryWithButtons: 640, buttonLabel: 20, name: 80 };

// The plan ladder, as `StudioPlanSku` ranks it.
const RANK = { free: 0, standard: 1, pro: 2 };
export const planAllows = (plan, required) => RANK[plan || 'free'] >= RANK[required || 'free'];
export const highestPlan = plans => plans.reduce((best, plan) => (RANK[plan] > RANK[best] ? plan : best), 'free');
